import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAppQuery } from "shared/api/baseQuery";


const ENDPOINT = "system-notification";
const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseAppQuery,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  tagTypes: ["notification"],
  endpoints: (builder) => ({
    getNotificationByCode: builder.query<{text: string, code: string}, {code: string}>({
      query: ({code}) => {
        return `${ENDPOINT}/fetch-by-code/${code}`;
      },
      providesTags: ["notification"],
    }),
  }),
});

export const { useGetNotificationByCodeQuery } = notificationApi;
export default notificationApi;